<template>
    <!-- 计数器组件 -->
    <el-input-number 
    v-model="value" 
    :min="min" 
    :max="max" 
    :label="label"
    :disabled="disabled"
    :step="step"
    :step-strictly="stepStrictly"
    :precision="precision"
    :size="size"
    :controls-position="ctrlPosition"
    :controls="ctrl"
    :name="name"
    :placeholder="placeholder"
    @focus="focus"
    @change="change" 
    @blur="blur"
    />
</template>
<script>
export default {
    name:"VelInputNum",
    props:{
        initValue:Number,
        min:Number,
        max:Number,
        label:String,
        step:Number,
        precision:Number,
        size:String,
        ctrlPosition:String,
        name:String,
        placeholder:String,
        isDisable:Boolean,
        isStepStrictly:Boolean,
        isCtrl:Boolean,
    },
    data() {
        return {
            value:0,
            ctrl:true,
            stepStrictly:false,
            disabled:false,
        };
    },
    created() {
        // this.getValue()
        this.initDataFn()
    },
    watch: {
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
        initDataFn(){
            this.isDisable ? this.disabled = true : this.disabled
            this.isStepStrictly ? this.stepStrictly = true : this.stepStrictly
            this.isCtrl ? this.ctrl = false : this.ctrl
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = 0
        },
        focus(){
            this.$emit('focus')
        },
        change(val){
            this.$emit('change',val)
        },
        blur(){
            this.$emit('blur')
        }
    }
}
</script>